var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dimensions"},[_c('span',{staticClass:"length"},[_vm._v(_vm._s(_vm.size.length)+"mm")]),_c('span',{staticClass:"width"},[_vm._v(_vm._s(_vm.size.width)+"mm")]),_c('span',{staticClass:"height"},[_vm._v(_vm._s(_vm.size.height)+"mm")]),_c('img',{attrs:{"src":_vm.getImage('powerpack-image/dimensionsPP.png')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }